// extracted by mini-css-extract-plugin
export var root = "rxRL";
export var rootCol = "aEwJ";
export var rootColMobileOpened = "goby";
export var rootColWithTiles = "nLxi";
export var rootLabel = "pLGn";
export var rootLabelIcon = "IUVP";
export var rootList = "rTnU";
export var rootListItem = "joka";
export var rootListItemImage = "wh6e";
export var rootListItemLink = "oNU6";
export var rootListItemPicture = "n7Vz";
export var rootListItemTile = "omt0";